var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitzerland(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "496.062px",
    height: "496.062px",
    viewBox: "0 0 496.062 496.062",
    enableBackground: "new 0 0 496.062 496.062",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect171",
    fill: "#FA000B",
    width: 496.062,
    height: 496.062
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g566",
    transform: "matrix(0.700000,0.000000,0.000000,0.700000,-124.0158,6.332397e-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect557",
    x: 310.039,
    y: 287.893,
    fill: "#FFFFFF",
    width: 442.913,
    height: 132.873
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect565",
    x: 465.059,
    y: 132.874,
    fill: "#FFFFFF",
    width: 132.874,
    height: 442.912
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitzerland);
export default __webpack_public_path__ + "static/media/switzerland.2c1c8c35.svg";
export { ForwardRef as ReactComponent };